module.exports = __webpack_public_path__ + "static/img/ss.a8a9caee.png";